import UnlockRulesCard from "./UnlockRulesCard";

export default UnlockRulesCard;
